import "core-js/modules/es.array.concat";
var shapeMap = {
  square: 'S',
  landscape: 'L',
  portrait: 'P',
  wide: 'W',
  tall: 'T'
};
var shrinkMap = {
  crop: 'C',
  fit: 'F'
};
export default function useSizeTypeFromFragments(mediaSizeMap, size, shape, shrink) {
  var mappedSize = (mediaSizeMap || {})[size] || 'small';
  return mappedSize === 'original' ? 'original' : "".concat(mappedSize).concat(shapeMap[shape] || 'L').concat(shrinkMap[shrink] || 'F');
}